/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import * as React from "react"

import BackgroundAudio from "./src/components/background-audio.js"

import "./src/styles/global.css"

/**
 * Shell persists across client-side route changes; children swap per page.
 * Audio itself lives in `document.body` via singleton so it never resets.
 */
export const wrapPageElement = ({ element }) => (
  <>
    <BackgroundAudio />
    {element}
  </>
)
